module.exports = __webpack_public_path__ + "static/media/Internationalcase9.33463d31.png";